<template>
  <div
    :class="{
      'configurator-wrapper': true,
      'configurator-wrapper--dim': isDialogOpen,
    }">
    <div class="configurator">
      <div
        @click.prevent="toggle"
        class="configurator-trigger"
        v-if="!isFullscreen">
        <div class="img-wrapper">
          <img :src="currentAdvisorPath">
        </div>
      </div>
      <div
        :class="{
          'configurator-window': true,
          'configurator-window--fullscreen': isFullscreen
        }" v-if="isDialogOpen">
        <div :class="{
          'configurator-content': true,
          'configurator-content--fullscreen': isFullscreen
        }">
          <div class="configurator-content-inner">
            <configurator
              @toggle="toggle"
              @setWindowMode="updateWindowMode"
            />
          </div>
          <div
            v-if="!isFullscreen"
            @click.prevent="toggle"
            class="configurator-content--close">
            <icon src="/product-advisor/images/icons/close.svg" />
          </div>
        </div>
        <div
          v-if="!isFullscreen"
          class="configurator-arrow-wrapper">
          <div class="configurator-arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        answers: 'answers',
        advisorIcon: 'advisorIcon',
        advisorIcons: 'advisorIcons',
      }),
      currentAdvisorPath() {
        let currentAdvisor = this.advisorIcon
        if (currentAdvisor) {
          let ca = this.advisorIcons.find(advisor => advisor.id === currentAdvisor)
          if (ca) {
            return ca.icon
          }
        }
      }
    },
    data() {
      return {
        isDialogOpen: false,
        isFullscreen: false,
      }
    },
    created() {
      let paths = window.location.pathname.split('/')
      if (paths) {
        paths.shift()
        let language = paths.shift()
        if (language) {
          language = language.split('-')
          this.$i18n.locale = language[1]
        }
      }

      // Check if any advisor has been set yet.
      if (!this.advisorIcon) {
        let randomizedAdvisorIcon = this.advisorIcons[Math.floor(Math.random() * this.advisorIcons.length)]
        if (randomizedAdvisorIcon) {
          this.$store.commit('setAdvisorIcon', randomizedAdvisorIcon?.id)
        }
      }
    },
    mounted() {
      if (this.$store.getters.currentLevel !== 'PRE0' || !document.cookie.includes('advisor=')) {
        this.isDialogOpen = true
        if (!document.cookie.includes('advisor=')) {
          this.setCookie('advisor', 'true', 30)
        }
      }
    },
    methods: {
      toggle() {
        this.isDialogOpen = !this.isDialogOpen
        if (!this.isDialogOpen) {
          this.isFullscreen = false
        }
      },
      updateWindowMode($event) {
        this.isFullscreen = $event
        if (window.innerWidth > 640) {
          this.isFullscreen = false
        }
      },
      setCookie(name,value,days) {
        let expires = ""
        if (days) {
          let date = new Date()
          date.setTime(date.getTime() + (days*24*60*60*1000))
          expires = "; expires=" + date.toUTCString()
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/"
      }
    },
  }
</script>

<style lang="scss" scoped>
  .configurator-wrapper {
    @apply
      fixed
      right-0
      bottom-0
      bg-transparent;

    &.configurator-wrapper--dim {
      @apply
        w-full
        h-full
        bg-ctm-black
        bg-opacity-70;
    }

    .configurator {
      @apply
        flex
        w-full
        h-full
        sm:items-end
        flex-col-reverse;

      .configurator-trigger {
        @apply
          flex
          justify-end
          flex-grow-0
          flex-shrink-0
          cursor-pointer;

        .img-wrapper {
          @apply
            mb-2
            w-24
            h-20;
        }

        img {
          @apply
            rounded-full
            shadow-ctm;
        }
      }

      .configurator-window {
        @apply
          flex
          w-full
          h-auto
          sm:w-96
          sm:h-134
          flex-col
          justify-end
          flex-grow-0
          flex-shrink-0;
        max-height: calc(100% - 128px);

        &.configurator-window--fullscreen {
          @apply
            w-full
            h-full
            sm:w-96
            bg-white
            sm:h-auto
            max-h-full;
        }

        .configurator-content {
          @apply
            px-6
            w-full
            relative
            max-h-full
            rounded;
          height: calc(100% - 20px);

          &.configurator-content--fullscreen {
            @apply
            px-0
            w-full
            h-full
            bg-white
            items-start;
          }

          .configurator-content-inner {
            @apply
              h-full
              rounded
              bg-white
              max-h-full;
          }

          .configurator-content--close {
            @apply
              h-6
              w-6
              flex
              -top-3
              right-3
              rounded
              bg-white
              absolute
              items-center
              justify-center
              cursor-pointer
              text-ctm-primary;
          }
        }

        .configurator-arrow-wrapper {
          @apply
            flex
            h-10
            -mb-5
            w-full
            justify-end
            flex-grow-0
            flex-shrink-0;

          .configurator-arrow {
            @apply
              w-4
              h-4
              mr-10
              inline
              border-16
              border-white
              bg-transparent;
              border-bottom-color: transparent;
              border-right-color: transparent;
              border-left-color: transparent;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  @import '~@/assets/scss/app';
</style>
